export const MailIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2.83398C1.72386 2.83398 1.5 3.05784 1.5 3.33398V12.6673C1.5 12.9435 1.72386 13.1673 2 13.1673H14C14.2761 13.1673 14.5 12.9435 14.5 12.6673V3.33398C14.5 3.05784 14.2761 2.83398 14 2.83398H2ZM2.5 5.3583V3.83398H13.5V5.3583L8 8.44163L2.5 5.3583ZM2.5 6.47633V12.1673H13.5V6.47634L8 9.55967L2.5 6.47633Z"
      fill="white"
    />
  </svg>
);

export const AppleIcon = () => (
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.09575 0H8.0009C7.29129 0.0936782 6.55065 0.514645 6.14666 0.987719C5.71106 1.49534 5.35157 2.14582 5.4148 3.07264C6.3627 3.147 6.94878 2.65695 7.37677 2.15167C7.81296 1.64288 8.17186 0.940295 8.09575 0ZM10.8702 9.81338V9.78703C9.94277 9.34674 9.20037 8.59966 9.09732 7.32271C8.9814 5.91695 9.65998 5.09375 10.5183 4.54749C10.0733 3.85193 9.35318 3.4011 8.33853 3.24771C7.55907 3.13041 6.95328 3.35196 6.35068 3.57234C6.30057 3.59067 6.25049 3.60899 6.20033 3.6271C6.14608 3.64689 6.09202 3.66869 6.03806 3.69044C5.87013 3.75814 5.7033 3.82539 5.5358 3.83027C5.27984 3.83806 5.01275 3.7244 4.77647 3.62384C4.71115 3.59605 4.64819 3.56925 4.58847 3.54631C4.29749 3.43623 3.96551 3.32499 3.64057 3.27464C2.88236 3.15871 2.20144 3.41808 1.70611 3.72254C0.767576 4.29515 0.0614763 5.47666 0 6.92984V7.52646C0.145201 9.55693 0.925657 11.1436 1.93563 12.372C2.27814 12.7877 2.74828 13.249 3.33084 13.3333H3.60134C3.94037 13.2855 4.22165 13.177 4.50035 13.0695C4.87383 12.9254 5.24265 12.7831 5.73954 12.7912C6.14758 12.7982 6.48419 12.929 6.81798 13.0588C7.15521 13.1899 7.48957 13.3199 7.8918 13.3199C8.77275 13.3199 9.28508 12.6107 9.69728 12.0401C9.71847 12.0108 9.7394 11.9818 9.7601 11.9533C10.2238 11.3116 10.6038 10.6202 10.8702 9.81338Z"
      fill="white"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.25 7.25L2 7.25V8.75L7.25 8.75V14H8.75V8.75L14 8.75L14 7.25L8.75 7.25L8.75 2H7.25L7.25 7.25Z"
      fill="#5E5E6A"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6064_68443)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9987 15.1673C4.04066 15.1673 0.832031 11.9587 0.832031 8.00065C0.832031 4.04261 4.04066 0.833984 7.9987 0.833984C11.9567 0.833984 15.1654 4.04261 15.1654 8.00065C15.1654 11.9587 11.9567 15.1673 7.9987 15.1673ZM7.33203 4.33398V5.33398H8.66536V4.33398H7.33203ZM6.66536 7.33398H7.33203V11.334H8.66536V6.00065H6.66536V7.33398Z"
        fill="#434350"
      />
    </g>
    <defs>
      <clipPath id="clip0_6064_68443">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowDownIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.71559 9.88284C7.8718 10.0391 8.12507 10.0391 8.28128 9.88284L11.4813 6.68284C11.6375 6.52663 11.6375 6.27337 11.4813 6.11716C11.3251 5.96095 11.0718 5.96095 10.9156 6.11716L7.99844 9.03431L5.08128 6.11716C4.92507 5.96095 4.6718 5.96095 4.51559 6.11716C4.35939 6.27337 4.35939 6.52663 4.51559 6.68284L7.71559 9.88284Z"
      fill="white"
    />
  </svg>
);
